import apiService from './apiService';

class DepartmentService {
  async createDepartment(data) {
    return apiService.post('/departments', data);
  }

  async joinDepartment(joinCode) {
    return apiService.post('/departments/join', { join_code: joinCode });
  }

  async listDepartments() {
    return apiService.get('/departments');
  }

  async getDepartment(id) {
    return apiService.get(`/departments/${id}`);
  }

  async updateDepartment(id, data) {
    return apiService.put(`/departments/${id}`, data);
  }

  async listResponders(id) {
    return apiService.get(`/departments/${id}/responders`);
  }

  async rotateJoinCode(id) {
    return apiService.post(`/departments/${id}/rotate-code`, {});
  }

  async removeResponder(departmentId, userId) {
    return apiService.delete(`/departments/${departmentId}/responders/${userId}`);
  }
}

const departmentService = new DepartmentService();
export default departmentService;
